import type { Group, GroupsQuery } from '@partou/my-group/data';
import { Injectable } from '@angular/core';
import { DEFAULT_LIMIT, type Paginated } from '@partou/core';
import { Observable, of } from 'rxjs';
import { MOCK_GROUPS_LIST } from '../constants/mock-groups.const';

@Injectable()
export class MockGroupsApiService {
  getGroups(query: GroupsQuery = {}): Observable<Paginated<Group>> {
    let matched: ReadonlyArray<Group> = MOCK_GROUPS_LIST;
    if (query.locationId !== undefined && query.locationId !== '') {
      matched = matched.filter((group: Group): boolean => group.location.id === query.locationId);
    }
    const search: string = (query.nameSearch ?? '').trim().toLocaleLowerCase('nl');
    if (search !== '') {
      matched = matched.filter((group: Group): boolean => group.name.toLocaleLowerCase('nl').includes(search));
    }
    const offset: number = query.offset ?? 0;
    const limit: number = query.limit ?? DEFAULT_LIMIT;
    return of({ items: matched.slice(offset, offset + limit), total: matched.length });
  }
}
